import receiptHeading           from '@/components/mixins/ReceiptHeading.js'
import fmt                      from '@/components/mixins/fmt.js'

//import { mapGetters }           from 'vuex'
export default {

    mixins   : [fmt,receiptHeading ],
     data() {
        return {
     
            //deskId     : 0,
            rowsText   : [],
            printerIP  : ''

        }
    },
    computed :{
   
        //...mapGetters(['storeId']) , 
    },
async mounted()
  {
     this.printerIP = JSON.parse(localStorage.getItem("printerIP"))  
  },

    methods  : {    

      setPrint(type,data)
      {
        if(type=='RICEVUTA')
        {
          this.printRicevuta()
        }  
        if(type=='CORTESIA')
        {
          this.printTicketCortesia(data)
        }
        if(type=='PRECONTO')
        {
          this.printPreConto(data)
        }
        if(type=='COUPON')
        {
          this.printCoupon(data)
        }
      },


async printRicevuta() {


    const newLine = "\x0A"  
    const cols = 42
    const pad  = ' '
    const xmlNewLine = '<text>' + newLine + '</text>'
    
    const deskId = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    
    //this.printerIP = JSON.parse(localStorage.getItem("printerIP"))      
    this.rowsText = await this.getReceiptHeading(this.storeId,this.deskId)      


      let param = '<parameter xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">'
          param += '<devid>local_printer</devid>'
          param += '<timeout>10000</timeout>'
          param += '</parameter>'

      let xml = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` 
      
      // HEADER 
      xml = this.addHeader(this.rowsText,xml,xmlNewLine)

      
      xml += xmlNewLine   
      xml += xmlNewLine   
      let spc    = cols - 15
      xml += '<text em="true">' + 'DESCRIZIONE' + pad.repeat(spc) + 'EURO'  + '</text>'  //text to print      
      xml += '<text em="false">' + '</text>'  //text to print      
      let total = 0
      let subtotal = 0
      let data = ''
      let saleId = ''
      this.items.forEach(item => {


         if(item.rowType == 0 || item.rowType == 1)
        {
          const m = item.rowType == 0 ? 1 : -1
          const price = this.fmt1(item.rowTotal * m)
          const product = (item.barcode + ' '  + item.category + pad.repeat(25)).substring(0,29) + ' '

          total = total + Number(item.rowTotal*m)
          spc = cols - product.length - price.length
          
          xml += '<text>' + product + pad.repeat(spc) +  price  + '</text>'  //text to print
          xml += xmlNewLine
          
    
          
          if(data.length==0)
          {

            data = item.create_at + ' ' + item.hour_at
            
            saleId = item.saleId
          }
            
          
        }
        subtotal = item.totalDiscount
    })


    total = total - subtotal
    if(subtotal > 0)
    {
      subtotal = this.fmt1(subtotal)      
      spc = cols - 9 -  subtotal.length
      xml += '<text>' + 'SCONTO' + ' ' + pad.repeat(spc) + '- ' + subtotal  + '</text>'  //text to print      
      xml += xmlNewLine      
    }
       
    total = this.fmt1(total)
    
    spc = cols - 12 - total.length
    xml += xmlNewLine

    xml += '<text height="2" em="true">' + 'TOTALE EURO ' + pad.repeat(spc) +  total  + '</text>'  //text to print
    xml += xmlNewLine
    xml += xmlNewLine
    

    let total1 = '0,00'
    let total2 = '0,00'  
    let total3 = '0,00'
    let total4 = '0,00'

    // CASH
    let payment = this.payments.filter(row => row.typeId == 'CASH')
    if(payment.length>0)
    {
     total1 = this.fmt1(payment[0].amount)
     
    }
    
    // ELEC PAGO LIGHT SCALA PAY
    payment = this.payments.filter(row => row.typeId == 'ELEC' || row.typeId == 'PAGO' || row.typeId == 'SCAL' || row.typeId == 'KLAR' )
    let total_payment = 0
    if(payment.length>0)
    {
      payment.forEach(payment=>{
        total_payment += payment.amount
      })
      total2 = this.fmt1(total_payment)
      
    }
    
    // NOT PAID
    payment = this.payments.filter(row => row.typeId == 'CRED')
    if(payment.length>0)
    {
      total3 = this.fmt1(payment[0].amount)
    }

    // COUPON
    payment = this.payments.filter(row => row.typeId == 'COUP')
    if(payment.length>0)
    {
      total4 = this.fmt1(payment[0].amount)
    }

    spc = cols - 18 - total1.length
    
    xml += '<text height="1"  em="false">' + 'PAGAMENTO CONTANTE' + pad.repeat(spc) +  total1  + '</text>'  //text to print
    xml += xmlNewLine
    spc = cols - 21 - total2.length
    xml += '<text>' + 'PAGAMENTO ELETTRONICO' +  pad.repeat(spc) + total2  + '</text>'  //text to print
    xml += xmlNewLine
    spc = cols - 16 - total4.length
    xml += '<text>' + 'PAGAMENTO COUPON' +  pad.repeat(spc) + total4 + '</text>'  //text to print
    xml += xmlNewLine
    spc = cols - 12 - total3.length
    xml += '<text>' + 'NON RISCOSSO' + pad.repeat(spc) +  total3  + '</text>'  //text to print
    xml += xmlNewLine
    xml += xmlNewLine
    
    let tot_items = this.items.length-1
    spc = cols - 15 - tot_items.toString().length
    xml += '<text>'  + 'TOTALE ARTICOLI' + pad.repeat(spc) +  tot_items + '</text>'   //text to print
    xml += xmlNewLine
    xml += xmlNewLine
    xml += '<text>' +  data + '</text>'   
    xml += xmlNewLine
    xml += xmlNewLine
    

    xml += '<text align="center"/>' 
    xml += '<barcode font="font_a" height="60" width="2" hri="below" type="code39">S' + saleId +  '</barcode>'
    xml += xmlNewLine

    // FOOTER
    xml = this.addFooter(this.rowsText,xml,xmlNewLine)
    
      xml += `<feed line="5"/> <cut type="feed"/></epos-print>`;    
      const soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<s:Header>' + param + '</s:Header><s:Body>' + xml +
          '</s:Body></s:Envelope>';

      this.printData(soap)

      
    },

async printPreConto(data) {

    const storeId    = data.storeId
    const deskId     = data.deskId
    const items      = data.cart
    const total      = data.total
    const discount   = data.discount    
    const percentage = data.percentage
    const newLine = "\x0A"  
    const cols = 42
    const pad  = ' '
    const xmlNewLine = '<text>' + newLine + '</text>'
    
    
    
    //this.printerIP = JSON.parse(localStorage.getItem("printerIP"))      
    this.rowsText = await this.getReceiptHeading(storeId,deskId)      

      let param = '<parameter xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">'
          param += '<devid>local_printer</devid>'
          param += '<timeout>10000</timeout>'
          param += '</parameter>'

      let xml = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` 

      // HEADER
      xml = this.addHeader(this.rowsText,xml,xmlNewLine)

      
      xml += xmlNewLine
      xml += xmlNewLine
      xml += '<text em="true">PRECONTO DEL ' + this.fmtDate() + '</text>' 
    
      xml += xmlNewLine   
      xml += xmlNewLine   
      let spc    = cols - 15
      xml += '<text em="true">' + 'DESCRIZIONE' + pad.repeat(spc) + 'EURO'  + '</text>'  //text to print      
      xml += '<text em="false">' + '</text>'  //text to print      
      //let total = 0
    
      items.forEach(item => {
        
        const retail_price = this.fmt1(item.price)
        const rowTotal     = this.fmt1(item.rowTotal)
        const discount     = item.discount
        let discount_val = 0
        
        if(item.rowTotal < 0)
        {
            discount_val = item.price - (item.rowTotal * -1)
        }
        else
        {
            discount_val = item.price - item.rowTotal
        }    
        
        const product = item.barcode + ' ' +  item.category                         
        spc = cols - product.length - retail_price.length          
        xml += '<text>' +  product + pad.repeat(spc) +  retail_price + '</text>'   //text to print
        xml += xmlNewLine   
        
        if(discount > 0)
        {    
            const description1 = 'SCONTO ' + discount + '%   ' + this.fmt1(discount_val) 
            spc = cols - description1.length - rowTotal.length
            xml += '<text>' + description1 + pad.repeat(spc) + rowTotal + '</text>'
            xml += xmlNewLine
            xml += xmlNewLine
        }
          
    })

    xml += xmlNewLine  

     if(discount != '0.00')
    {
        const subTotal = this.fmt1(total)      
        spc = cols - 10 -  subTotal.length
        xml += '<text>SUBTOTALE' + ' ' + pad.repeat(spc) + subTotal + '</text>'   //text to print
        xml += xmlNewLine      
    }
    

    if(discount != '0.00')
      {
        const percent = percentage
        const total = this.fmt1(discount)      
        const description2 = 'SCONTO CASSA ' + percent + '%'  
        spc = cols - description2.length - total.length -1
        xml += '<text>' + description2  +  pad.repeat(spc) + '-' + total  + '</text>'
        xml += xmlNewLine      
      }


    const grandTotal  = this.fmt1(total - discount)
    //cmds += GS + '!' +  '\x01'
    spc = cols - 12 - grandTotal.length
    xml += '<text height="2" em="true">TOTALE EURO ' + pad.repeat(spc) +  grandTotal  + '</text>'
    xml += xmlNewLine      
    xml += xmlNewLine      
    //cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)


    const tot_items = items.length
    spc = cols - 15 - tot_items.toString().length
    xml += '<text height="1" em="false">TOTALE ARTICOLI' + pad.repeat(spc) +  tot_items + '</text>'
    xml += xmlNewLine  
    xml += xmlNewLine  
    xml += xmlNewLine  
     

      xml += `<feed line="5"/> <cut type="feed"/></epos-print>`;    
      const soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<s:Header>' + param + '</s:Header><s:Body>' + xml +
          '</s:Body></s:Envelope>';

      this.printData(soap)

      
    },




async printTicketCortesia(item) {

    
    const data   = item.create_at + ' ' + item.hour_at
    const saleId = item.saleId
   
    const newLine = "\x0A"  
    const xmlNewLine = '<text>' + newLine + '</text>'    
    const deskId = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    
    this.printerIP = JSON.parse(localStorage.getItem("printerIP"))      
    this.rowsText = await this.getReceiptHeading(this.storeId,this.deskId)      

      let param = '<parameter xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">'
          param += '<devid>local_printer</devid>'
          param += '<timeout>10000</timeout>'
          param += '</parameter>'

      let xml = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` 
  
      // HEADER
      xml = this.addHeader(this.rowsText,xml,xmlNewLine)
    
      xml += xmlNewLine   
      xml += xmlNewLine   

      //let data = this.items[0].create_at + ' ' + this.items[0].hour_at
      
      xml += xmlNewLine
      xml += '<text align="center"/>' 
      xml += '<text em="true">' + 'SCONTRINO DI CORTESIA'  + '</text>'  //text to print      
      
      xml += '<text em="false">' + '</text>'  //text to print          
      xml += xmlNewLine
      
      
      xml += '<text align="center"/>' 
      xml += '<barcode font="font_a" height="60" width="2" hri="below" type="code39">S' + saleId +  '</barcode>'
      xml += xmlNewLine
      xml += xmlNewLine
      xml += '<text>' +  data + '</text>'   
    
      xml += xmlNewLine

      // FOOTER
      xml = this.addFooter(this.rowsText,xml,xmlNewLine)   

      xml += `<feed line="5"/> <cut type="feed"/></epos-print>`

      const soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<s:Header>' + param + '</s:Header><s:Body>' + xml +
          '</s:Body></s:Envelope>';

      this.printData(soap)

      
    },

async printCoupon(item) {

    const newLine    = "\x0A"  
    const xmlNewLine = '<text>' + newLine + '</text>'    
    const deskId     = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    
    
    this.rowsText = await this.getReceiptHeading(this.storeId,this.deskId)      

      let param = '<parameter xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">'
          param += '<devid>local_printer</devid>'
          param += '<timeout>10000</timeout>'
          param += '</parameter>'

      let xml = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` 
    
    // HEADER
    xml = this.addHeader(this.rowsText,xml,xmlNewLine)  
    
    xml += xmlNewLine   
    xml += xmlNewLine   

    const total = this.fmt1(item.total)
    xml  += xmlNewLine
        
    xml += '<text font="font_a"/>'
            xml += '<text width="1" height="2"/>'
           /* xml += '<feed unit="30"/>' */
            xml += '<text>' + 'COUPON EURO' + '</text>' 

    xml += xmlNewLine
    
    xml += '<text font="font_b"/>'
    xml += '<text width="3" height="3"/>'        
    xml += '<text>' + total + '</text>' 

    xml += xmlNewLine
    xml += xmlNewLine

    xml += '<text font="font_a"/>'
    xml += '<text width="1" height="1"/>'


    xml += '<text>' + item.reference + '</text>' 
    xml += xmlNewLine
    

    xml += '<text font="font_a"/>'
    xml += '<text width="1" height="1"/>'
    xml += '<text>' + 'valido fino al ' + item.expire_at  + '</text>' 
    xml += xmlNewLine
  
    if(item.note)
    {
      xml += '<text font="font_a"/>'
      xml += '<text width="1" height="1"/>'
      xml += '<text>' + item.note + '</text>' 
      xml += xmlNewLine
      
    }

    /*
    xml += '<text font="font_a"/>'
    xml += '<text width="1" height="1"/>'
    xml += '<text>' + item.create_at + '</text>' 
    xml += xmlNewLine
  */

      xml += xmlNewLine    
      xml += '<text align="center"/>' 
      xml += '<barcode font="font_a" height="60" width="2" hri="below" type="ean13">' + item.barcode +  '</barcode>'
      xml += xmlNewLine
      xml += xmlNewLine
      
     
      xml += '<text font="font_a"/>'
      xml += '<text width="1" height="1"/>'
      xml += '<text>' + item.create_at + '</text>' 
      xml += xmlNewLine

      // FOOTER
      xml = this.addFooter(this.rowsText,xml,xmlNewLine)   

      xml += `<feed line="5"/> <cut type="feed"/></epos-print>`

      const soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<s:Header>' + param + '</s:Header><s:Body>' + xml +
          '</s:Body></s:Envelope>';

      this.printData(soap)

    },

    printData(soap)
    {

      // Imposta l'indirizzo della stampante
      const printerIP = this.printerIP + "/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000"
      
      fetch(printerIP, {
        method  : "POST",
        headers : 
        {
          "Content-Type": "text/xml"
        },
        body    : soap
      })
      /*.then(response => response.text())*/
      .then(result => {
        this.spinner2 = false
        console.log("Risposta dalla stampante:\n", result);
        //alert("Stampa inviata con successo.");
      })
      .catch(error => 
      {
        this.spinner2 = false
        console.error("Errore:", error);
        alert(error)
        //this.alert_msg =  "Errore durante la stampa. " +  error
        //alert("Errore durante la stampa.");
      });

    },
    addHeader(rows,xml,xmlNewLine)
    {
      
      rows.forEach(row => {
      if(row.type == 'H')
      {
        if(row.order_by == 1)
        {   

            xml += '<text align="center"/>' 
            xml += '<text font="font_b"/>'
            xml += '<text width="2" height="2"/>'
            xml += '<text>' + row.text + '</text>' 
            xml += xmlNewLine
                                    
        }
        else
        {

          /* xml += '<text align="center"/>' */
            xml += xmlNewLine 
            xml += '<text font="font_a"/>'
            xml += '<text width="1" height="1"/>'
           /* xml += '<feed unit="30"/>' */
            xml += '<text>' + row.text + '</text>' 
            //xml += xmlNewLine   

            
        }
        
      }

      })

      return xml


    },
    addFooter(rows,xml,xmlNewLine)
    {
      
      rows.forEach(row=>{

      if(row.type=='F')
      { 
        
        xml += '<text>' + row.text + '</text>'
        xml += xmlNewLine  
        /*
        if(row.text == 'Come riconoscimento del debito')
        {  
          if(total3 != '0,00') 
          {
            xml += '<text>' + row.text + '</text>'
            xml += xmlNewLine  
          }
          
        }
        else
        {
          xml += '<text>' + row.text + '</text>'
          xml += xmlNewLine  
          
        }
        */
      }
      })
      return xml
    
    }


    }
}